/* eslint-disable */
import React, { useState, useEffect } from 'react';

const AddAndEditDashboardView = (props) => {
    const [naicsSearchQuery, setNaicsSearchQuery] = useState('');
    const [parentSearchQuery, setParentSearchQuery] = useState('');
    const [companySearchQuery, setCompanySearchQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState({ naics: '', parent: '', company: '' });
    const [dashViewFormState, setDashViewFormState] = useState({
        name: props.dashboardViewModalState.edit_view.name || '',
        viewVisibilty: props.dashboardViewModalState.edit_view.private ? 'only_me' : 'all',
        displayViewPermissionQ: !props.dashboardViewModalState.edit_view.private,
        displayApplyQ: ['userDashboard', 'practice', 'industry'].includes(props.report) ? false : true,
        viewPermission: props.dashboardViewModalState.edit_view.permission_details === 'view_only' ? 'view_only' : 'edit_and_view',
        viewApply: props.dashboardViewModalState.edit_view.view_apply ? props.dashboardViewModalState.edit_view.view_apply : props.editorPage ? 'all_firm_clients' : 'current_client',
        naicsSpecific: props.dashboardViewModalState.naicsSpecific,
        parentSpecific: props.dashboardViewModalState.parentSpecific,
        metricKey: props.dashboardViewModalState.metric_key,
        metricName: props.dashboardViewModalState.metric_name,
    })
    const [naicsSearch, setNaicsSearch] = useState({
        isLoading: false,
        selected: props.dashboardViewModalState.naicsSearch,
        results: []
    })
    const [parentSearch, setParentSearch] = useState({
        isLoading: false,
        selected: props.dashboardViewModalState.parentSearch,
        results: []
    })
    const [companySearch, setCompanySearch] = useState({
        isLoading: false,
        selected: props.dashboardViewModalState.companySearch,
        results: []
    })

    const findAccountNameByKey = (data, key) => {
        for (const [category, items] of data) {
            for (const [account, value] of items) {
                if (value === key) {
                    return account;
                }
            }
        }
        return null;
    }

    const handleDashViewForm = (type, value) => {
        setDashViewFormState((prevState) => {
            switch (type) {
                case 'name':
                    return {
                        ...prevState,
                        name: value,
                    }
                case 'viewPermission':
                    return {
                        ...prevState,
                        viewPermission: value,
                    }
                case 'viewApply':
                    return {
                        ...prevState,
                        viewApply: value,
                    }
                case 'viewVisibilty':
                    return {
                        ...prevState,
                        viewVisibilty: value,
                        displayViewPermissionQ: value === 'all'
                    }
                case 'naicsSpecific':
                    return {
                        ...prevState,
                        naicsSpecific: value
                    }
                case 'parentSpecific':
                    return {
                        ...prevState,
                        parentSpecific: value
                    }
                case 'metricKey':
                    let accountName = findAccountNameByKey(props.dashboardViewModalState.pvdAccountsWithKeys, value)
                    return {
                        ...prevState,
                        metricKey: value === 'subtotal' ? null : value,
                        metricName: value === 'subtotal' ? null : accountName
                    }
            }
        })

    }

    const handleSelectedNAICS = (action, naicsCode) => {
        if (action === 'add') {
            setNaicsSearch(prevState => {
                let newResults = prevState.results.filter(naics => naics !== naicsCode)
                let newSelected = [...prevState.selected, naicsCode]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setNaicsSearch(prevState => {
                let newSelected = prevState.selected.filter(naics => naics !== naicsCode)
                let newResults = [naicsCode, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleSelectedParent = (action, parent) => {
        if (action === 'add') {
            setParentSearch(prevState => {
                let newResults = prevState.results.filter(p => p.id !== parent.id)
                let newSelected = [...prevState.selected, parent]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setParentSearch(prevState => {
                let newSelected = prevState.selected.filter(p => p.id !== parent.id)
                let newResults = [parent, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleSelectedCompany = (action, company) => {
        if (action === 'add') {
            setCompanySearch(prevState => {
                let newResults = prevState.results.filter(p => p.id !== company.id)
                let newSelected = [...prevState.selected, company]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setCompanySearch(prevState => {
                let newSelected = prevState.selected.filter(p => p.id !== company.id)
                let newResults = [company, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleNAICSInputChange = (e) => {
        setNaicsSearchQuery(e.target.value);
    };

    const handleParentInputChange = (e) => {
        setParentSearchQuery(e.target.value);
    };

    const handleCompanyInputChange = (e) => {
        setCompanySearchQuery(e.target.value);
    }

    const handleAddEditViewSubmit = (e) => {
        e.preventDefault()
        let formData = dashViewFormState
        formData["naics"] = dashViewFormState.naicsSpecific === 'yes' ? naicsSearch.selected : null
        formData["parent_ids"] = dashViewFormState.parentSpecific === 'yes' ? parentSearch.selected.map(p => p.id) : null
        formData["company_ids"] = dashViewFormState.viewApply === 'specific_clients' ? companySearch.selected.map(p => p.id) : null

        if (props.dashboardViewModalState.action === 'add_view') {
            props.createDashBoardView(formData)
            setDashViewFormState(prevState => {
                return { ...prevState, name: '' }
            })
        } else {
            props.updateDashBoardView(false, props.dashboardViewModalState.edit_view.id, formData)
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery({
                naics: naicsSearchQuery,
                parent: parentSearchQuery,
                company: companySearchQuery
            });
        }, 1000);

        return () => clearTimeout(handler);
    }, [naicsSearchQuery, parentSearchQuery, companySearchQuery]);

    useEffect(() => {
        const fetchSearchData = async (queryType, queryValue) => {
            if (!queryValue) return;

            if (queryType === 'naics') {
                setNaicsSearch(prev => ({ ...prev, isLoading: true }));
            } else if (queryType === 'company' && props.adminEditor) {
                setParentSearch(prev => ({ ...prev, isLoading: true }));
            } else {
                setCompanySearch(prev => ({ ...prev, isLoading: true }));
            }

            try {
                const response = await fetch(`/api/v1/${queryType}_search/?term=${queryValue}`);
                if (!response.ok) throw new Error('Network error');

                const data = await response.json();

                if (queryType === 'naics') {
                    let filteredNaics = []
                    data.results.forEach(n => {
                        if (!naicsSearch.selected.includes(n)) {
                            filteredNaics.push(n)
                        }
                    })
                    setNaicsSearch(prev => ({ ...prev, isLoading: false, results: filteredNaics }));
                } else if (queryType === 'company' && props.adminEditor) {
                    let filteredParent = []
                    data.admin_results.forEach(p => {
                        if (!parentSearch.selected.find(r => r.id === p.id)) {
                            filteredParent.push(p)
                        }
                    })
                    setParentSearch(prev => ({ ...prev, isLoading: false, results: filteredParent }));
                } else {
                    let filteredCompanies = []
                    data.firm_results.forEach(p => {
                        if (!companySearch.selected.find(r => r.id === p.id)) {
                            filteredCompanies.push(p)
                        }
                    })
                    setCompanySearch(prev => ({ ...prev, isLoading: false, results: filteredCompanies }));
                }
            } catch (error) {
                console.error(`Error fetching ${queryType} data:`, error);
            }
        };

        fetchSearchData('naics', debouncedQuery.naics);
        fetchSearchData('company', debouncedQuery.parent);
        fetchSearchData('company', debouncedQuery.company);
    }, [debouncedQuery]);


    if (props.editorPage) {
        return (
            <div>
                <h3>{props.dashboardViewModalState.action === 'add_view' ? 'Create A New Report' : 'Edit Report'}</h3>
                <p>Click Anywhere Outside of this Pop-up to Close</p>
                <form id='new-dashboard-view-form' onSubmit={(e) => handleAddEditViewSubmit(e)}>
                    <div className='dash-view-name'>
                        <label htmlFor='dashboard-view-name'>Report Name:</label>
                        <input
                            type='text'
                            id='dashboard-view-name'
                            maxLength='30'
                            placeholder="Ex. Bob's First Report"
                            value={dashViewFormState.name}
                            onChange={(e) => handleDashViewForm('name', e.target.value)}
                            required
                        />
                    </div>
                    {!props.adminEditor && <>
                        <div className='one-line-q'>
                            <span>Can all firm users to view this report in the report builder or only you?</span>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-view'
                                    name='dashboard-view-visibility'
                                    value='all'
                                    checked={dashViewFormState.viewVisibilty === 'all'}
                                    onChange={(e) => handleDashViewForm('viewVisibilty', e.target.value)}
                                    required
                                />
                                <label htmlFor='all-view'>All</label>
                            </div>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='only-me-view'
                                    name='dashboard-view-visibility'
                                    value='only_me'
                                    checked={dashViewFormState.viewVisibilty === 'only_me'}
                                    onChange={(e) => handleDashViewForm('viewVisibilty', e.target.value)} />
                                <label htmlFor='only-me-view'>Only Me</label>
                            </div>
                        </div>
                        {
                            dashViewFormState.displayViewPermissionQ
                                ? (<div className='one-line-q'>
                                    <span>Can other users edit or just view your report?</span>
                                    <div className='dash-view-radio-q'>
                                        <input
                                            type='radio'
                                            id='permit-edit-and-view'
                                            name='dashboard-view-permissions'
                                            value='edit_and_view'
                                            checked={dashViewFormState.viewPermission === 'edit_and_view'}
                                            onChange={(e) => handleDashViewForm('viewPermission', e.target.value)}
                                            required
                                        />
                                        <label htmlFor='permit-edit-and-view'>Both Edit & View</label>
                                    </div>
                                    <div className='dash-view-radio-q'>
                                        <input
                                            type='radio'
                                            id='permit-view'
                                            name='dashboard-view-permissions'
                                            value='view_only'
                                            checked={dashViewFormState.viewPermission === 'view_only'}
                                            onChange={(e) => handleDashViewForm('viewPermission', e.target.value)}
                                        />
                                        <label htmlFor='permit-view'>Only View</label>
                                    </div>
                                </div>)
                                : null
                        }
                    </>
                    }
                    {!props.adminEditor && <>
                        <div>
                            <span>Is this report accessible to all clients?</span>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-firm-clients'
                                    name='dashboard-view-apply'
                                    value='all_firm_clients'
                                    checked={dashViewFormState.viewApply === 'all_firm_clients'}
                                    onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='all-firm-clients'>All Firm Clients</label>
                            </div>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-my-clients'
                                    name='dashboard-view-apply'
                                    value='all_firm_clients_naics'
                                    checked={dashViewFormState.viewApply === 'all_firm_clients_naics'}
                                    onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='all-my-clients'>All Clients with the same NAICS code</label>
                            </div>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-my-clients-naics'
                                    name='dashboard-view-apply'
                                    value='specific_clients'
                                    checked={dashViewFormState.viewApply === 'specific_clients'}
                                    onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='all-my-clients-naics'>Specific Clients</label>
                            </div>
                            <div>
                                {
                                    dashViewFormState.viewApply === 'specific_clients'
                                        ? (<div className='search-clients-section'>
                                            <input className='client-search-bar' placeholder='Search for Client' type="text" onChange={(e) => handleCompanyInputChange(e)} />
                                            <div className='clients-search-wrap'>
                                                <span>Selected</span>
                                                {companySearch.selected.map(s => {
                                                    return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedCompany('remove', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                                })}
                                            </div>
                                            <div className='clients-search-wrap'>
                                                <span>Results</span>
                                                {companySearch.results.map(s => {
                                                    return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedCompany('add', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                                })}
                                            </div>
                                        </div>)
                                        : null
                                }
                            </div>

                        </div>
                    </>
                    }


                    {props.adminEditor && <>
                        <div className='one-line-q'>
                            <span>Is this NAICS specific?</span>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='naics-yes'
                                    name='dashboard-view-visibility'
                                    value='yes'
                                    checked={dashViewFormState.naicsSpecific === 'yes'}
                                    onChange={(e) => handleDashViewForm('naicsSpecific', e.target.value)}
                                    required
                                />
                                <label htmlFor='naics-yes'>Yes</label>
                            </div>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='naics-no'
                                    name='dashboard-view-visibility'
                                    value='no'
                                    checked={dashViewFormState.naicsSpecific === 'no'}
                                    onChange={(e) => handleDashViewForm('naicsSpecific', e.target.value)} />
                                <label htmlFor='naics-no'>No</label>
                            </div>
                        </div>
                        <div>
                            {
                                dashViewFormState.naicsSpecific === 'yes'
                                    ? (<div className='search-clients-section'>
                                        <input className='client-search-bar' placeholder='Search for NAICS' type="text" onChange={(e) => handleNAICSInputChange(e)} />
                                        <div className='clients-search-wrap'>
                                            <span>Selected</span>
                                            {naicsSearch.selected.map(s => {
                                                return <div key={s} className='company-name-btn' onClick={() => handleSelectedNAICS('remove', s)}><span>{s}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                            })}
                                        </div>
                                        <div className='clients-search-wrap'>
                                            <span>Results</span>
                                            {naicsSearch.results.map(s => {
                                                return <div key={s} className='company-name-btn' onClick={() => handleSelectedNAICS('add', s)}><span>{s}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                            })}
                                        </div>
                                    </div>)
                                    : null
                            }
                        </div>
                    </>
                    }

                    {props.adminEditor && <>
                        <div className='one-line-q'>
                            <span>Is this Firm / Parent Company specific?</span>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='parent-yes'
                                    name='dashboard-view-permissions'
                                    value='yes'
                                    checked={dashViewFormState.parentSpecific === 'yes'}
                                    onChange={(e) => handleDashViewForm('parentSpecific', e.target.value)}
                                    required
                                />
                                <label htmlFor='parent-yes'>Yes</label>
                            </div>
                            <div className='dash-view-radio-q'>
                                <input
                                    type='radio'
                                    id='parent-no'
                                    name='dashboard-view-permissions'
                                    value='no'
                                    checked={dashViewFormState.parentSpecific === 'no'}
                                    onChange={(e) => handleDashViewForm('parentSpecific', e.target.value)}
                                />
                                <label htmlFor='parent-no'>No</label>
                            </div>
                        </div>
                        <div>
                            {
                                dashViewFormState.parentSpecific === 'yes'
                                    ? (<div className='search-clients-section'>
                                        <input className='client-search-bar' placeholder='Search for Parent Company / Firm' type="text" onChange={(e) => handleParentInputChange(e)} />
                                        <div className='clients-search-wrap'>
                                            <span>Selected</span>
                                            {parentSearch.selected.map(s => {
                                                return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedParent('remove', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                            })}
                                        </div>
                                        <div className='clients-search-wrap'>
                                            <span>Results</span>
                                            {parentSearch.results.map(s => {
                                                return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedParent('add', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                            })}
                                        </div>
                                    </div>)
                                    : null
                            }
                        </div>
                    </>
                    }

                    {props.adminEditor && <>
                        <div className='one-line-q'>
                            <span>Which account should this Custom Report appear as a link on the Copilot?</span>
                            <select onChange={(e) => handleDashViewForm('metricKey', e.target.value)} value={dashViewFormState.metricKey}>
                                {props.dashboardViewModalState.pvdAccountsWithKeys.map((p, i) => (
                                    <optgroup label={p[0]} key={i}>
                                        {p[1].map((c, ii) => (
                                            <option key={`${c}-${ii}`} value={c[1]}>
                                                {c[0]}
                                            </option>
                                        ))}
                                    </optgroup>
                                ))}
                            </select>
                        </div>
                    </>}


                    <div className='dashboard-form-btn-section'>
                        <button className='btn dashboard-save-btn'>{props.dashboardViewModalState.action === 'add_view' ? 'Create New Report' : 'Save Changes'}</button>
                    </div>
                </form>
                <button onClick={() => props.handleDashboardViewModal('all_views')}>Edit Reports</button>
            </div>
        )
    } else {
        return (
            <div>
                <h3>{props.dashboardViewModalState.action === 'add_view' ? 'Create A New Dashboard View' : 'Edit Dashboard View'}</h3>
                <p>Click Anywhere Outside of this Pop-up to Close</p>
                <form id='new-dashboard-view-form' onSubmit={(e) => handleAddEditViewSubmit(e)}>
                    <div className='dash-view-name'>
                        <label htmlFor='dashboard-view-name'>View Name:</label>
                        <input
                            type='text'
                            id='dashboard-view-name'
                            maxLength='30'
                            placeholder="Ex. Bob's First View"
                            value={dashViewFormState.name}
                            onChange={(e) => handleDashViewForm('name', e.target.value)}
                            required
                        />
                    </div>
                    <div className='one-line-q'>
                        <span>Do you want all other firm users to view this dashboard or only you?</span>
                        <div className='dash-view-radio-q'>
                            <input
                                type='radio'
                                id='all-view'
                                name='dashboard-view-visibility'
                                value='all'
                                checked={dashViewFormState.viewVisibilty === 'all'}
                                onChange={(e) => handleDashViewForm('viewVisibilty', e.target.value)}
                                required
                            />
                            <label htmlFor='all-view'>All</label>
                        </div>
                        <div className='dash-view-radio-q'>
                            <input
                                type='radio'
                                id='only-me-view'
                                name='dashboard-view-visibility'
                                value='only_me'
                                checked={dashViewFormState.viewVisibilty === 'only_me'}
                                onChange={(e) => handleDashViewForm('viewVisibilty', e.target.value)} />
                            <label htmlFor='only-me-view'>Only Me</label>
                        </div>
                    </div>
                    {
                        dashViewFormState.displayViewPermissionQ
                            ? (<div className='one-line-q'>
                                <span>Can other users edit or just view your layout?</span>
                                <div className='dash-view-radio-q'>
                                    <input
                                        type='radio'
                                        id='permit-edit-and-view'
                                        name='dashboard-view-permissions'
                                        value='edit_and_view'
                                        checked={dashViewFormState.viewPermission === 'edit_and_view'}
                                        onChange={(e) => handleDashViewForm('viewPermission', e.target.value)}
                                        required
                                    />
                                    <label htmlFor='permit-edit-and-view'>Both Edit & View</label>
                                </div>
                                <div className='dash-view-radio-q'>
                                    <input
                                        type='radio'
                                        id='permit-view'
                                        name='dashboard-view-permissions'
                                        value='view_only'
                                        checked={dashViewFormState.viewPermission === 'view_only'}
                                        onChange={(e) => handleDashViewForm('viewPermission', e.target.value)}
                                    />
                                    <label htmlFor='permit-view'>Only View</label>
                                </div>
                            </div>)
                            : null
                    }
                    {dashViewFormState.displayApplyQ
                        ? (
                            <div>
                                <span>Do you want to apply this layout to other clients?</span>
                                {
                                    dashViewFormState.displayViewPermissionQ
                                        ? (<>
                                            <div className='dash-view-radio-q'>
                                                <input
                                                    type='radio'
                                                    id='all-firm-clients'
                                                    name='dashboard-view-apply'
                                                    value='all_firm_clients'
                                                    checked={dashViewFormState.viewApply === 'all_firm_clients'}
                                                    onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                                />
                                                <label htmlFor='all-firm-clients'>All Firm Clients</label>
                                            </div>

                                            <div className='dash-view-radio-q'>
                                                <input
                                                    type='radio'
                                                    id='all-firm-clients-naics'
                                                    name='dashboard-view-apply'
                                                    value='all_firm_clients_naics'
                                                    checked={dashViewFormState.viewApply === 'all_firm_clients_naics'}
                                                    onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                                />
                                                <label htmlFor='all-firm-clients-naics'>All Firm Clients with Same NAICS Codes</label>
                                            </div>
                                        </>)
                                        : null
                                }

                                <div className='dash-view-radio-q'>
                                    <input
                                        type='radio'
                                        id='all-my-clients'
                                        name='dashboard-view-apply'
                                        value='all_my_clients'
                                        checked={dashViewFormState.viewApply === 'all_my_clients'}
                                        onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                    />
                                    <label htmlFor='all-my-clients'>All My Clients</label>
                                </div>

                                <div className='dash-view-radio-q'>
                                    <input
                                        type='radio'
                                        id='all-my-clients-naics'
                                        name='dashboard-view-apply'
                                        value='all_my_clients_naics'
                                        checked={dashViewFormState.viewApply === 'all_my_clients_naics'}
                                        onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                    />
                                    <label htmlFor='all-my-clients-naics'>All My Clients with Same NAICS Codes</label>
                                </div>

                                <div className='dash-view-radio-q'>
                                    <input
                                        type='radio'
                                        id='just-this-client'
                                        name='dashboard-view-apply'
                                        value='current_client'
                                        checked={dashViewFormState.viewApply === 'current_client'}
                                        onChange={(e) => handleDashViewForm('viewApply', e.target.value)}
                                        required
                                    />
                                    <label htmlFor='just-this-client'>No, Just this Client</label>
                                </div>
                            </div>
                        )
                        : null
                    }
                    <div className='dashboard-form-btn-section'>
                        <button className='btn dashboard-save-btn'>{props.dashboardViewModalState.action === 'add_view' ? 'Create New View' : 'Save Changes'}</button>
                    </div>
                </form>
                <button onClick={() => props.handleDashboardViewModal('all_views')}>Edit My Views</button>
            </div>
        )
    }
}

export default AddAndEditDashboardView;